import { render, staticRenderFns } from "./ElementCard.vue?vue&type=template&id=c8f72c60"
import script from "./ElementCard.vue?vue&type=script&lang=js"
export * from "./ElementCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports